module.exports = __webpack_public_path__ + "static/media/project5.92abd026.jpg";